import { render } from "./RewardNewCaapExamResultModal.vue?vue&type=template&id=7cea7766"
import script from "./RewardNewCaapExamResultModal.vue?vue&type=script&lang=js"
export * from "./RewardNewCaapExamResultModal.vue?vue&type=script&lang=js"

import exportComponent from "/builds/skilltech-ph/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__